/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * FilesLegacyControllerApi - axios parameter creator
 * @export
 */
export const FilesLegacyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (adminId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('deleteFile', 'adminId', adminId)
            const localVarPath = `/files/{adminId}`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: async (fileId: string, context: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getFile', 'fileId', fileId)
            // verify required parameter 'context' is not null or undefined
            assertParamExists('getFile', 'context', context)
            const localVarPath = `/files/public/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileId: async (adminId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('getFileId', 'adminId', adminId)
            const localVarPath = `/files/{adminId}`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFile: async (body?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} adminId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFileAdmin: async (adminId: string, body?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('postFileAdmin', 'adminId', adminId)
            const localVarPath = `/files/{adminId}`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} adminId 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishFile: async (adminId: string, context: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('publishFile', 'adminId', adminId)
            // verify required parameter 'context' is not null or undefined
            assertParamExists('publishFile', 'context', context)
            const localVarPath = `/files/{adminId}/publish`
                .replace(`{${"adminId"}}`, encodeURIComponent(String(adminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesLegacyControllerApi - functional programming interface
 * @export
 */
export const FilesLegacyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesLegacyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(adminId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(adminId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(fileId: string, context: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFile(fileId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileId(adminId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileId(adminId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFile(body?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.postFile(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} adminId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFileAdmin(adminId: string, body?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.postFileAdmin(adminId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} adminId 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishFile(adminId: string, context: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.publishFile(adminId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FilesLegacyControllerApi - factory interface
 * @export
 */
export const FilesLegacyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesLegacyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(adminId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFile(adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(fileId: string, context: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFile(fileId, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileId(adminId: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getFileId(adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFile(body?: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.postFile(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} adminId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFileAdmin(adminId: string, body?: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.postFileAdmin(adminId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} adminId 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishFile(adminId: string, context: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.publishFile(adminId, context, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesLegacyControllerApi - interface
 * @export
 * @interface FilesLegacyControllerApi
 */
export interface FilesLegacyControllerApiInterface {
    /**
     * 
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApiInterface
     */
    deleteFile(adminId: string, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} fileId 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApiInterface
     */
    getFile(fileId: string, context: string, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApiInterface
     */
    getFileId(adminId: string, options?: any): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApiInterface
     */
    postFile(body?: string, options?: any): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @param {string} adminId 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApiInterface
     */
    postFileAdmin(adminId: string, body?: string, options?: any): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @param {string} adminId 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApiInterface
     */
    publishFile(adminId: string, context: string, options?: any): AxiosPromise<{ [key: string]: string; }>;

}

/**
 * FilesLegacyControllerApi - object-oriented interface
 * @export
 * @class FilesLegacyControllerApi
 * @extends {BaseAPI}
 */
export class FilesLegacyControllerApi extends BaseAPI implements FilesLegacyControllerApiInterface {
    /**
     * 
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApi
     */
    public deleteFile(adminId: string, options?: any) {
        return FilesLegacyControllerApiFp(this.configuration).deleteFile(adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApi
     */
    public getFile(fileId: string, context: string, options?: any) {
        return FilesLegacyControllerApiFp(this.configuration).getFile(fileId, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApi
     */
    public getFileId(adminId: string, options?: any) {
        return FilesLegacyControllerApiFp(this.configuration).getFileId(adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApi
     */
    public postFile(body?: string, options?: any) {
        return FilesLegacyControllerApiFp(this.configuration).postFile(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} adminId 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApi
     */
    public postFileAdmin(adminId: string, body?: string, options?: any) {
        return FilesLegacyControllerApiFp(this.configuration).postFileAdmin(adminId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} adminId 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesLegacyControllerApi
     */
    public publishFile(adminId: string, context: string, options?: any) {
        return FilesLegacyControllerApiFp(this.configuration).publishFile(adminId, context, options).then((request) => request(this.axios, this.basePath));
    }
}
